import axios from 'axios';
import moment from 'moment';
import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Session from 'types/Session';
import SourceSessionType from 'sources/sourceTypes/Session';
import * as mapper from 'sources/mapper/Session';
import { PaginationParams } from 'sources/sourceTypes/Pagination';

export interface SessionParams extends PaginationParams {
  startTime?: moment.Moment;
  endTime?: moment.Moment;
}

class SessionSource extends BaseSource<
  Session,
  SourceSessionType,
  SessionParams
> {
  public ObjectURL = 'sessions' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;

  public async checkIn(id: string, clientIds: number[]): Promise<Session> {
    const response = await axios.post<SourceSessionType>(
      `${this.Url}/${id}/check_in`,
      /* eslint-disable @typescript-eslint/camelcase */
      { client_ids: clientIds },
      /* eslint-enable @typescript-eslint/camelcase */
      this.headers
    );
    return this.toType(response.data);
  }

  public async checkOut(id: string, clientIds: number[]): Promise<Session> {
    const response = await axios.post<SourceSessionType>(
      `${this.Url}/${id}/check_out`,
      /* eslint-disable @typescript-eslint/camelcase */
      { client_ids: clientIds },
      /* eslint-enable @typescript-eslint/camelcase */
      this.headers
    );
    return this.toType(response.data);
  }
}

const sessionSource = new SessionSource();

export default sessionSource;
